import React from "react";
import "./cellActions.css";
import { ArrowBtnMobile } from "../../../assets/logos/icons";
import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import { GRID_COL_INDEX_ATTRIBUTE } from "@progress/kendo-react-grid";
import { useMediaQuery } from "@material-ui/core";

const CellActionsNew = (props) => {
  let { actions, onArrowClick } = props
  const navigationAttributes = useTableKeyboardNavigation(props.id);

  const showArrow = useMediaQuery(`(max-width:820px)`);

  return (
    <td
      style={props.style} // this applies styles that lock the column at a specific position
      className={props.className} // this adds classes needed for locked columns
      colSpan={props.colSpan}
      role={"gridcell"}
      aria-colindex={props.ariaColumnIndex}
      aria-selected={props.isSelected}
      {...{
        [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
      }}
      {...navigationAttributes}
    >
      <div className="gridPure-cellActions-container" style={{ justifyContent: 'center' }}>
        {
          actions && actions.length > 0 &&
          actions.map((action) => {
            const { onClick, type, value } = action
            return (
              <>
                {
                  type === 'label' &&
                  <button
                    key={value}
                    className="gridPure-cellActions-labelBtn"
                    onClick={() => { onClick(props.dataItem) }}
                  >
                    {value}
                  </button>
                }

                {
                  type === 'icon' &&
                  <button
                    key={value}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                    className="gridPure-cellActions-IconBtn"
                    onClick={() => { onClick(props.dataItem) }}
                  >
                    <i style={{ pointerEvents: 'none' }}
                      className={value}
                    ></i>
                  </button>
                }

                {
                  type === 'view-details' &&
                  <button
                    key={value}
                    className={`gridPure-cellActions-viewDetails ${showArrow ? "gridPure-cellActions-arrowBtn" : "gridPure-cellActions-labelBtn"}`}
                    onClick={() => { onClick(props.dataItem) }}
                  >
                    {
                      showArrow
                        ? <img alt={"Arrow button"} src={ArrowBtnMobile} />
                        : value
                    }
                  </button>
                }
              </>
            )
          })
        }

        {
          onArrowClick && !actions.find(action => action.type === 'view-details') &&
          <button
            className="gridPure-cellActions-arrowBtn"
            onClick={() => { onArrowClick(props.dataItem) }}
          >
            <img
              alt={"Arrow button"}
              src={ArrowBtnMobile}
            />
          </button>
        }
      </div>
    </td>
  );
}

export default CellActionsNew